import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationModalService {
  isOpen = signal(false);
  isLoading = signal<boolean>(false);
  justOkBtn = signal<boolean>(false);
  title = signal<string>('Notificación');
  message = signal<string>('Este es el mensaje de la notificación.');
  response = signal<boolean | null>(null); // Guardará la respuesta del usuario

  /**
   * Opens a notification modal with the specified title, message, and button configuration.
   *
   * @param title - The title to display in the modal.
   * @param message - The message to display in the modal.
   * @param justOkBtn - Optional. If `true`, the modal will display only an "OK" button. Defaults to `false`.
   * @returns A promise that resolves to a boolean value indicating the user's response:
   *          - `true` if the user confirmed.
   *          - `false` if the user canceled.
   *
   * The modal will remain open until the user's response is captured. Once a response is received,
   * the modal will automatically close, and the promise will resolve with the response value.
   */
  open(title: string, message: string, justOkBtn: boolean = false, isLoading?: boolean): Promise<boolean> {

    this.title.set(title);
    this.message.set(message);
    this.isOpen.set(true);
    this.response.set(null); // Resetear el valor anterior
    this.justOkBtn.set(justOkBtn);
    if (isLoading) this.isLoading.set(isLoading);
    else  this.isLoading.set(false);

    return new Promise<boolean>((resolve) => {
      const interval = setInterval(() => {
        if (this.response() !== null) {
          clearInterval(interval);
          this.isOpen.set(false); // Cierra el modal automáticamente
          resolve(this.response()!);
        }
      }, 100);
    });
  }


  accept() {
    this.response.set(true);
  }

  close() {
    this.response.set(false);
  }
}
